var _a;
const customDirectory = process.env.simDir
    ? require(`${process.env.simDir}`)
    : undefined;
const numParticipants = parseInt((_a = process.env.simZoomParticipants) !== null && _a !== void 0 ? _a : '0', 10);
export class Directory {
    static create(callTypes) {
        const directory = customDirectory ? Object.values(customDirectory) : Directory.directory;
        return directory.map((entry) => {
            var _a;
            const newEntry = Object.assign(Object.assign({}, entry), { contacts: {} });
            let i = 0;
            for (const key of Object.keys((_a = entry.contacts) !== null && _a !== void 0 ? _a : {}).sort()) {
                const contact = entry.contacts[key];
                if (callTypes.includes(contact.type)) {
                    newEntry.contacts[`a${i++}`] = contact;
                }
            }
            return newEntry;
        });
    }
}
Directory.directory = [
    {
        contacts: {
            a0: {
                name: 'Work',
                number: '5553331000',
                type: 'audio',
            },
            a1: {
                name: 'Desktop',
                number: '5553331000',
                type: 'zoom',
            },
        },
        firstName: 'Paul',
        lastName: 'Roberts',
        onMobile: true,
        onDesktop: false,
        picture: 'img/directory/paulRoberts.png',
        presence: 'online',
    },
    {
        contacts: {
            a0: {
                name: 'Work',
                number: '5553331001',
                type: 'audio',
            },
            a1: {
                name: 'Desktop',
                number: '5553331001',
                type: 'zoom',
            },
        },
        firstName: 'Steve',
        lastName: 'Joiner',
        onMobile: false,
        onDesktop: true,
        picture: 'img/directory/steveJoiner.jpg',
        presence: 'online',
    },
    {
        contacts: {
            a0: {
                name: 'Work',
                number: '5553331002',
                type: 'audio',
            },
            a1: {
                name: 'Desktop',
                number: '5553331002',
                type: 'zoom',
            },
        },
        firstName: 'Craig',
        lastName: 'Richardson',
        onMobile: true,
        onDesktop: false,
        picture: 'img/directory/craigRichardson.jpg',
        presence: 'online',
    },
    {
        contacts: {
            a0: {
                name: 'Work',
                number: '5553331003',
                type: 'audio',
            },
            a1: {
                name: 'Desktop',
                number: '5553331003',
                type: 'zoom',
            },
        },
        firstName: 'Tom',
        lastName: 'Drewes',
        onMobile: false,
        onDesktop: true,
        picture: 'img/directory/tomDrewes.jpg',
        presence: 'online',
    },
    {
        contacts: {
            a0: {
                name: 'Work',
                number: '5553331004',
                type: 'audio',
            },
            a1: {
                name: 'Desktop',
                number: '5553331004',
                type: 'zoom',
            },
        },
        firstName: 'Marion',
        lastName: 'Richardson',
        onMobile: false,
        onDesktop: true,
        picture: 'img/directory/marionRichardson.jpg',
        presence: 'busy',
    },
    {
        contacts: {
            a0: {
                name: 'Work',
                number: '5553331005',
                type: 'audio',
            },
            a1: {
                name: 'Desktop',
                number: '5553331005',
                type: 'zoom',
            },
        },
        firstName: 'Betty',
        lastName: 'Decker',
        onMobile: true,
        onDesktop: false,
        picture: 'img/directory/f1.jpg',
        presence: 'online',
    },
    {
        contacts: {
            a0: {
                name: 'Work',
                number: '5553331006',
                type: 'audio',
            },
            a1: {
                name: 'Desktop',
                number: '5553331006',
                type: 'zoom',
            },
        },
        firstName: 'Sharon',
        lastName: 'McAllister',
        onMobile: true,
        onDesktop: false,
        picture: 'img/directory/f2.jpg',
        presence: 'online',
    },
    {
        contacts: {
            a0: {
                name: 'Work',
                number: '5553331007',
                type: 'audio',
            },
            a1: {
                name: 'Desktop',
                number: '5553331007',
                type: 'zoom',
            },
        },
        firstName: 'Ronda',
        lastName: 'Elbert',
        onMobile: true,
        onDesktop: false,
        picture: 'img/directory/f3.jpg',
        presence: 'online',
    },
    {
        contacts: {
            a0: {
                name: 'Work',
                number: '5553331008',
                type: 'audio',
            },
            a1: {
                name: 'Desktop',
                number: '5553331008',
                type: 'zoom',
            },
        },
        firstName: 'Melissa',
        lastName: 'Xavier',
        onMobile: false,
        onDesktop: true,
        picture: 'img/directory/f4.jpg',
        presence: 'online',
    },
    {
        contacts: {
            a0: {
                name: 'Work',
                number: '5553331009',
                type: 'audio',
            },
            a1: {
                name: 'Desktop',
                number: '5553331009',
                type: 'zoom',
            },
        },
        firstName: 'Crystal',
        lastName: 'Cooper',
        onMobile: true,
        onDesktop: false,
        picture: 'img/directory/f5.jpg',
        presence: 'busy',
    },
    {
        contacts: {
            a0: {
                name: 'Work',
                number: '5553331010',
                type: 'audio',
            },
            a1: {
                name: 'Desktop',
                number: '5553331010',
                type: 'zoom',
            },
        },
        firstName: 'Ina',
        lastName: 'Prochaska',
        onMobile: false,
        onDesktop: true,
        picture: 'img/directory/f6.jpg',
        presence: 'online',
    },
    {
        contacts: {
            a0: {
                name: 'Work',
                number: '5553331011',
                type: 'audio',
            },
            a1: {
                name: 'Desktop',
                number: '5553331011',
                type: 'zoom',
            },
        },
        firstName: 'Kim',
        lastName: 'Fritz',
        onMobile: true,
        onDesktop: false,
        picture: 'img/directory/f7.jpg',
        presence: 'away',
    },
    {
        contacts: {
            a0: {
                name: 'Work',
                number: '5553331012',
                type: 'audio',
            },
            a1: {
                name: 'Desktop',
                number: '5553331012',
                type: 'zoom',
            },
        },
        firstName: 'Nikil',
        lastName: 'Tapert',
        onMobile: false,
        onDesktop: true,
        picture: 'img/directory/m3.jpg',
        presence: 'dnd',
    },
    {
        contacts: {
            a0: {
                name: 'Work',
                number: '5553331013',
                type: 'audio',
            },
            a1: {
                name: 'Desktop',
                number: '5553331013',
                type: 'zoom',
            },
        },
        firstName: 'Freddy',
        lastName: 'Hernandez',
        onMobile: true,
        onDesktop: false,
        picture: 'img/directory/m4.jpg',
        presence: 'online',
    },
    {
        contacts: {
            a0: {
                name: 'Work',
                number: '5553331014',
                type: 'audio',
            },
            a1: {
                name: 'Desktop',
                number: '5553331014',
                type: 'zoom',
            },
        },
        firstName: 'Mark',
        lastName: 'Guo',
        onMobile: false,
        onDesktop: true,
        picture: 'img/directory/m5.jpg',
        presence: 'online',
    },
    {
        contacts: {
            a0: {
                name: 'Work',
                number: '5553331015',
                type: 'audio',
            },
            a1: {
                name: 'Desktop',
                number: '5553331015',
                type: 'zoom',
            },
        },
        firstName: 'Darryl',
        lastName: 'DeBarge',
        onMobile: false,
        onDesktop: true,
        picture: 'img/directory/m6.jpg',
        presence: 'away',
    },
    {
        contacts: {
            a0: {
                name: 'Work',
                number: '5553331016',
                type: 'audio',
            },
            a1: {
                name: 'Desktop',
                number: '5553331016',
                type: 'zoom',
            },
        },
        firstName: 'Ying',
        lastName: 'Bao',
        onMobile: false,
        onDesktop: true,
        picture: 'img/directory/m7.jpg',
        presence: 'online',
    },
    {
        contacts: {
            a0: {
                name: 'Work',
                number: '5553331017',
                type: 'audio',
            },
            a1: {
                name: 'Desktop',
                number: '5553331017',
                type: 'zoom',
            },
        },
        firstName: 'Prashanth',
        lastName: 'Mathur',
        onMobile: false,
        onDesktop: true,
        picture: 'img/directory/m8.jpg',
        presence: 'online',
    },
    {
        contacts: {
            a0: {
                name: 'Work',
                number: '5553331018',
                type: 'audio',
            },
            a1: {
                name: 'Desktop',
                number: '5553331018',
                type: 'zoom',
            },
        },
        firstName: 'Puri',
        lastName: 'Singh',
        onMobile: false,
        onDesktop: true,
        picture: 'img/directory/m9.jpg',
        presence: 'online',
    },
    {
        contacts: {
            a0: {
                name: 'Work',
                number: '5553331019',
                type: 'audio',
            },
            a1: {
                name: 'Desktop',
                number: '5553331019',
                type: 'zoom',
            },
        },
        firstName: 'Wally',
        lastName: 'Waldorf',
        onMobile: true,
        onDesktop: false,
        picture: 'img/directory/wallywaldorf.jpg',
        presence: 'busy',
    },
    {
        contacts: {
            a0: {
                name: 'Work',
                number: '5553331020',
                type: 'audio',
            },
            a1: {
                name: 'Desktop',
                number: '5553331020',
                type: 'zoom',
            },
        },
        firstName: 'Beatrice',
        lastName: 'Kim',
        onMobile: true,
        onDesktop: false,
        picture: 'img/directory/beatricekim.jpg',
        presence: 'dnd',
    },
];
Directory.numParticipants = Number.isNaN(numParticipants) ? 0 : numParticipants;
